import { BasePageContent } from "../../../core/content/base-page-content.component";

export class PagecontentSearchCriteriaPage extends BasePageContent {
  getPageSpecificText() {
    this.PAGE_TEXT["searchcriteria"] = {
      left_header: `Specific Search`,
      left_subtext: `Provide any of the following search information and click SEARCH.`,
      right_header: `View All Construction General Permits`,

      lbl_ltf: `LTF ID#:`,
      lbl_companyName: `Company Name:`,
      lbl_facilityName: `Facility Name:`,
      lbl_county: `Facility County:`,

      lbl_search: `SEARCH`,
      lbl_search_all: `VIEW ALL`,
    };
  }
}
